import data from './data'
import computed from './computed'
import components from './components'
import mounted from './mounted'

export default {
  data,
  components,
  mounted,
  computed,
  resourcePath: '/v1/dweller/meetings'
}



// WEBPACK FOOTER //
// ./src/app/tenant/meeting/resources/index.js